import { agencyApis } from '@apis/dashboard/agencyApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useAgencyStaffs = createUseQuery(
  (id: number) => ['/dashboard/agency/{id}/staff/', id],
  (id) => () =>
    agencyApis.get('/dashboard/agency/{id}/staff/', { path: { id } }).then((r) => r[200]!),
);
